/* RESPONSIBLE TEAM: team-ai-agent */
import AutomationFinAIAgentEscalationRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/escalation';

export default class AutomationFinAIAgentEcommerceEscalationRoute extends AutomationFinAIAgentEscalationRoute {
  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.escalation',
  };

  beforeModel() {
    if (!this.appService.app.canUseFinEcommerceAgent) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.setup');
      return;
    }
  }
}
